import { Loader2, Send } from "lucide-react";
import { FIELD } from "../hooks/useSimpleForm";

const SECTORS = [
  "Petit commerce / Boutique",
  "Artisan / Métier de bouche",
  "Avocat / Cabinet juridique",
  "Agent immobilier",
  "Profession libérale",
  "Indépendant / Freelance",
  "Autre",
];

const OFFERS = [
  ["Starter", "Starter — 450 €"],
  ["Pro", "Pro — 700 €"],
  ["Premium", "Premium — 950 €"],
];

const Field = ({ id, label, children }) => (
  <div>
    <label className="mb-1.5 block text-xs font-semibold text-navy" htmlFor={id}>{label}</label>
    {children}
  </div>
);

export const ContactForm = ({ form, set, submit, loading }) => (
  <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <Field id="contact-name" label="Nom *">
        <input id="contact-name" data-testid="contact-name-input" className={FIELD} placeholder="Marie Dupont" value={form.name} onChange={set("name")} required minLength={2} />
      </Field>
      <Field id="contact-phone" label="Téléphone *">
        <input id="contact-phone" data-testid="contact-phone-input" type="tel" className={FIELD} placeholder="06 12 34 56 78" value={form.phone} onChange={set("phone")} required minLength={6} />
      </Field>
    </div>
    <Field id="contact-email" label="Email *">
      <input id="contact-email" data-testid="contact-email-input" type="email" className={FIELD} placeholder="marie@exemple.fr" value={form.email} onChange={set("email")} required />
    </Field>
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <Field id="contact-sector" label="Votre activité">
        <select id="contact-sector" data-testid="contact-sector-select" className={FIELD} value={form.sector} onChange={set("sector")}>
          <option value="">Choisir…</option>
          {SECTORS.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </Field>
      <Field id="contact-offer" label="Offre souhaitée">
        <select id="contact-offer" data-testid="contact-offer-select" className={FIELD} value={form.offer} onChange={set("offer")}>
          <option value="">Je ne sais pas encore</option>
          {OFFERS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </Field>
    </div>
    <Field id="contact-message" label="Votre projet *">
      <textarea id="contact-message" data-testid="contact-message-input" className={`${FIELD} min-h-28 resize-y`} placeholder="Nous sommes boulangers à Annecy et nous aimerions un site pour présenter la boutique…" value={form.message} onChange={set("message")} required minLength={5} />
    </Field>
    <button
      type="submit"
      data-testid="contact-submit-button"
      disabled={loading}
      className="group flex w-full items-center justify-center gap-2 rounded-full bg-navy px-6 py-3.5 text-sm font-semibold text-white transition-all hover:bg-navy-light hover:shadow-lg hover:shadow-gold/25 disabled:opacity-60"
    >
      {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={15} className="transition-transform group-hover:translate-x-0.5" />}
      {loading ? "Envoi en cours…" : "Envoyer ma demande"}
    </button>
  </form>
);
